<template>
    <div>
        <div class="container-fluid featured-image-services">
            <div class="feature-header-page">
                <h1>Our Services</h1>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12 my-services">
                    <h2>Our Services</h2>
                    <hr>
                    <p>We have a wide range of vehicles to choose to travel in all of which are listed below….</p>
                    <ul>
                        <li>Estate Car (Eco friendly) 4 passengers with lots of luggage
                            Space.
                        </li>
                        <li>Saloon Car (Eco friendly) 4 passengers with lots of luggage
                            Space.
                        </li>
                        <li>Minibus that can take 7 passengers with luggage space</li>
                    </ul>
                    <p>All our vehicles are climate controlled with hi-tech satellite navigation systems ensuring we get to your destination comfortably using the fastest and most efficient route.</p>
                    <p><b>Airports & Sea Ports</b></p>
                    <p>We cover all airports & sea ports no matter what time of day you wish to book.<br>
                        We also offer a discounted rate when a return journey is pre booked with us. <br>
                        By using our enquiry page, we are able to offer a free, no obligation quotation at the click of a button making it easier to book wherever you are and whenever you wish.
                    </p>
                    <p><b>NHS</b></p>
                    <p>Due to popular demand, we are pleased to offer a heavily discounted rate to an NHS service when a return journey is booked.
                        <br>
                        With the option of a ‘sit & wait’ service if you can ensure that we return you at the earliest opportunity when your appointment/visit is complete.
                        <br>
                        Our friendly and helpful drivers will be on hand to assist you or those closest to you at each end of the journey giving you peace of mind.
                    </p>
                    <p><b>Business Accounts</b></p>
                    <p>We offer a 30 day credit account to any business looking to make regular corporate bookings. <br>
                        All journeys will be at a fixed rate and can be booked 24 hours a day, 7 days a week. <br>
                        So if you are looking for a reliable transport service, look no further and get in touch now via a number of options on the contact page.
                    </p>
                    <p><b>Senior Citizens</b></p>
                    <p>As of May 2019 Harling Taxis Ltd will be running Senior citizens lunch trips and days out at an easily affordable rate.
                        <br>
                        Please contact us at any time to put yourself or an elderly loved one on our contact list to be notified when an upcoming event will be taking place.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'my-services'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/OurServices.vue